import { Console } from "console";
import React, { FunctionComponent, useState, MutableRefObject, useEffect } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import Draggable from 'react-draggable';
import { LARGE, MEDIUM, SMALL } from "utils/constants";
import { getLocalStorage } from "utils";

interface IProps {
  onChange: (input: string) => void;
  keyboardRef: any;
  initialVal:any;
  keyboardclass:any
  handleenter:any
  positionClass:any
}


export const VirtualKeyboard: FunctionComponent<IProps> = ({
  onChange,
  keyboardRef,
  initialVal,
  keyboardclass,
  positionClass,
  handleenter,
}) => {
  const [layoutName, setLayoutName] = useState("default");
  const keyboardSize = getLocalStorage("keyboardSize") || MEDIUM;

  useEffect(()=>{
    if(initialVal && keyboardRef?.current?.setInput){
          keyboardRef.current.setInput(initialVal);
        }
  },[])

  const onKeyPress = (button: string) => {
    // debugger
    console.log("button" , button);
    if(button === "{enter}"){
      if(handleenter)
      handleenter();
    }

    if (button === "{shift}" || button === "{lock}") {
      setLayoutName(layoutName === "default" ? "shift" : "default");
    }
  };

  return (
    <Draggable  handle=".handle"
    defaultPosition={{x: 0, y: 0}}
    // bounds="body"
    >
      <div className={`mykeyboard ${positionClass ? positionClass:"absolute"} ${keyboardSize===LARGE ? "w-[650px]" :keyboardSize===SMALL? "w-[400px]":"w-[500px]" } z-[1900] ${keyboardclass ? keyboardclass:""}`}>
        <div className="handle draghere text-center bg-[#b5b5b5] h-[2rem] text-Black font-bold border-2">Drag here</div>
      <Keyboard
        keyboardRef={(r:any) => (keyboardRef.current = r)}
        layoutName={layoutName}
        onChange={onChange}
        onKeyPress={onKeyPress}
      />
      </div>
    </Draggable>
  );
};
















